module.exports = __webpack_public_path__ + "img/p14.50a84858.png";